import axios from 'axios';

import { API_DOMAIN } from '../constants'

export const instance = axios.create({
  baseURL: API_DOMAIN,
  timeout: 30000,
});


instance.interceptors.request.use(
  reqConfig => {
    if (!reqConfig.url.includes('refresh_token')){ // avoid override header if logging out
      const token = localStorage.getItem('access-token');
      reqConfig.headers.common = { 'Authorization': `Bearer ${token}` }
    }
    return reqConfig;
  },
  err => Promise.reject(err),
);

let isFetchingToken = false;
let tokenSubscribers = [];

function subscribeTokenRefresh(cb) {
  tokenSubscribers.push(cb);
}
function onTokenRefreshed(errRefreshing, token) {
  tokenSubscribers.map(cb => cb(errRefreshing, token));
}
function forceLogout() {
  isFetchingToken = false;
  localStorage.clear();
  window.location = '/login';
}

instance.interceptors.response.use(
  response => response,
  (error) => {
    
    const status = error.response ? error.response.status : null
    if (error.response.config.url.includes('/token')) return Promise.reject(error);
    if (status === 403) return forceLogout(); // Invalid refresh attempt
    if (status !== 401) return Promise.reject(error);  //Not Authorized

    if (!isFetchingToken) {
      isFetchingToken = true;

      const refreshToken = localStorage.getItem('refresh-token');
      if (!refreshToken) return forceLogout();
      const originalRequest = error.config;
      return instance.put('refresh_token', '', {headers: {
        'Authorization': `Bearer ${refreshToken}`
      }})
        .then(newAccessToken => {
          isFetchingToken = false;
          const token = newAccessToken.data.access_token
          tokenSubscribers = [];
          localStorage.setItem('access-token', token);
          originalRequest.__isRetryRequest = true
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          return instance(originalRequest);
        })
        .catch((error) => {
          onTokenRefreshed(new Error('Unable to refresh access token'), null);
          tokenSubscribers = [];
          forceLogout();
        })

    }
  });



// WEBPACK FOOTER //
// ./src/utils/axiosInstance.js